module.exports = __webpack_public_path__ + "3f4f13a25721ba2b04050431de88055c.pdf";